import { defineComponent as _defineComponent } from 'vue'
import BaseButton from "@/components/shared/button/base/BaseButton.vue";
import InlineSvg from "vue-inline-svg";
import { inject, onMounted, ref } from "vue";

import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import { useBoardStore } from "@/stores/boardStore";
import {
  ICustomCode,
  ICustomCodeCollection,
} from "@/domain/entities/system/customCode.types";
import ReportReasonButton from "../button/ReportReasonButton.vue";

import { IResultData } from "@/domain/entities/shared/result";
import { useGetReportReasons } from "@/composables/line/useGetReportReasons";
import { useRoute } from "vue-router";


const __default__ = {
  name: "ReportModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  boardUid: {
    type: String,
    required: true,
  },
  lineName: {
    type: String,
    required: true,
  },
  lineStartTime: {
    type: String,
    default: "",
  },
  busPlateNumber: {
    type: String,
    required: true,
  },
},
  emits: ["onClickCloseBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const route = useRoute();
const boardStore = useBoardStore();

const showModal = ref(true);
const selectedReason = ref<ICustomCode>();

const selectReason = (reason: ICustomCode) => {
  selectedReason.value = reason;
};

const closeReportModal = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  setTimeout(() => {
    emit("onClickCloseBtn");
  }, 300);
};

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const { reportReasons, fetchReportReasons } = useGetReportReasons({
  onError: (result: IResultData<ICustomCodeCollection>) => {
    handleError("신고 사유 조회 오류", result);
  },
});

const requestReport = async () => {
  if (!props.boardUid) {
    showToastMessage("신고 중 오류가 발생했습니다");
    return;
  }

  if (!selectedReason.value) {
    showToastMessage("신고 사유를 선택해주세요");
    return;
  }

  const reportResult = await boardStore.requestReport(
    props.boardUid,
    selectedReason.value
  );

  if (reportResult.isSuccess) {
    closeReportModal();
    showToastMessage("신고가 완료되었습니다");
  } else {
    handleError("신고 요청 오류", reportResult);
  }
};

onMounted(() => {
  route.meta.onBackHandlerList.push(closeReportModal);
  fetchReportReasons();
});

const __returned__ = { props, emit, showErrorModal, showToastMessage, route, boardStore, showModal, selectedReason, selectReason, closeReportModal, handleError, reportReasons, fetchReportReasons, requestReport, BaseButton, get InlineSvg() { return InlineSvg }, ReportReasonButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})